module.exports = __webpack_public_path__ + "static/img/contact_bg.50aaa33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/contact_bg.jpg
// module id = /sTl
// module chunks = 0